import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MuiScrollbarService } from '@move/ui';
import { MmuRouterHistoryService } from '../../../routing/mmu-router-history.service';
import { MmuReducedFrameConfig, MmuReducedFrameViewChild } from '../interfaces';


@Component({
  selector: 'mmu-reduced-frame',
  templateUrl: './mmu-reduced-frame.component.html',
  styleUrls: ['./mmu-reduced-frame.component.scss']
})
export class MmuReducedFrameComponent implements AfterViewInit {

  config: MmuReducedFrameConfig = {
    showBackLink: true,
    showBreadcrumbs: true
  };

  constructor(
    private mmuHistoryService: MmuRouterHistoryService,
    private route: ActivatedRoute,
    private scrollService: MuiScrollbarService
  ) {
  }

  ngAfterViewInit(): void {
    const scrollToElement: string | null = this.route.snapshot.queryParamMap.get('scroll');
    if (scrollToElement) {
      this.scrollService.scrollToElement(scrollToElement);
    }
  }

  activateChildComponent(component: MmuReducedFrameViewChild): void {
    if ('frameConfig' in component) {
      this.config = {
        ...this.config,
        ...component.frameConfig
      };
    }
  }

  goBack(): void {

    const hasEntries = this.mmuHistoryService.history.length > 1;

    if (hasEntries) {
      window.history.back();
      return;
    }

    window.open('/', '_self');
  }
}
